// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3dx9-","col":"styles_col__uzI6m"};